import axios from 'axios'
import { exportAxios } from '@/utils/axiosType'

export default {
  // 获取用户联系方式
  getContactInfo (params) {
    return axios.post('/api/rendering/admin/front/user/contact/getContactInfo', params)
  },
  // 更新用户联系方式
  updateContactInfo (params) {
    return axios.post('/api/rendering/admin/front/user/contact/updateContactInfo', params)
  },
  // 获取用户标签列表
  getUserTagList (params) {
    return axios.get('/api/rendering/admin/front/userlabel/get', params)
  },
  // 新版获取用户标签列表
  newGetUserTagList (params) {
    return axios.get('/api/rendering/admin/front/userlabel/getByTree', params)
  },
  // 列表页顶部添加用户标签（可多选用户）
  addUserLabel (params) {
    return axios.post('/api/rendering/admin/front/user/addUserLabel', params)
  },
  // 创建用户新标签
  addUserTag (params) {
    return axios.post('/api/rendering/admin/front/userlabel/add', params)
  },
  // 删除用户标签
  delUserTag (params) {
    return axios.post('/api/rendering/admin/front/userlabel/del', params)
  },
  // 展示用户列表
  getUserList (params) {
    return axios.post('/api/rendering/admin/front/user/queryUserList', params)
  },
  // 导出用户列表
  exportUserList (params) {
    return axios.post('/api/rendering/admin/front/user/exportUserList', params)
  },
  // 根据组织类型查询管理员
  queryAdminByOrganizationType (params) {
    return axios.post('/api/rendering/admin/base/user/queryAdminByOrganizationType', params)
  },
  // 一键转移客服或业务名下的用户
  moveUser (params) {
    return axios.post('/api/rendering/admin/base/user/moveUser', params)
  },
  // 分配管理员(TD、客服、业务、代理)
  allocateUserAdmin (params) {
    return axios.post('/api/rendering/admin/base/user/allocateUserAdmin', params)
  },
  // 根据IP获取区域ID
  queryAreaIdByIp (params) {
    return axios.post('/api/rendering/admin/front/user/queryAreaIdByIp', params)
  },
  // 导出所有手机号
  exportPhone (params) {
    return exportAxios('/api/rendering/admin/front/user/exportPhone', params)
  },
  // 添加备注
  addRemark (params) {
    return exportAxios('/api/rendering/admin/front/user/addRemark', params)
  },
  // 标记僵尸
  markZombies (params) {
    return axios.post('/api/rendering/admin/front/user/markZombies', params)
  },
  // 查询用户详情
  queryUserDetails (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryUserDetails', params)
  },
  // 查询用户硬件配置
  queryUserHardware (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/hardware/list', params)
  },
  // 查询多个用户是否欠费
  queryArrearUser (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/getUserAccountInfo', params)
  },
  // 修改用户详情
  updateUserDetails (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateUserDetails', params)
  },
  // 查询所有存储
  queryMountPath (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryMountPath', params)
  },
  // 重置密码
  resetPassword (params) {
    return axios.post('/api/rendering/admin/front/user/updatePwdByUserName', params)
  },
  // 获取临时登录密码
  getTempPassword (params) {
    return axios.post('/api/rendering/admin/front/user/getTempUserPassword', params)
  },
  // 获取API
  getUserApi (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/getUserApi', params)
  },
  // 设置API
  settUserApi (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/saveOrUpdateUserApi', params)
  },
  // 导出历史重复帧
  exportHistoryFrame (params) {
    return axios.post('/api/rendering/admin/statistics/pay/exportRepeatFrame', params)
  },
  // 安全设置
  setSafeList (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryIpLimitsByUserId', params)
  },
  // 导出用户详情消费列表
  exportConsumeList (params) {
    return exportAxios('/api/rendering/admin/task/rendering/exportUserConsumeList', params)
  },
  // 主子账号列表
  getUserAndSubUsers (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryUserAndSubUsersById', params)
  },
  // 账号变更记录
  getUserNameChangeRecord (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/getUserNameChangeRecord', params)
  },
  // 充值
  recharge (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/adminRechargeRecord', params)
  },
  // 退现金
  refundPay (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/refundPayRecord', params)
  },
  // 获取充值列表
  getRreditList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getRecordListByUserId', params)
  },
  // 作废订单（只针对订单状态为待确认收款）
  invalidPayRecord (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/invalidPayRecord', params)
  },
  // 设置充值订单不可开票
  setPayRecordNotInvoice (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/invalidPayRecordById', params)
  },
  // 是否银行流水号是否重复
  existTransactionId (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/existTransactionId', params)
  },
  // 检查预充值订单是否存在
  checkPreRechargeOrder (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/checkPreRechargeOrder', params)
  },
  // 客户跟踪记录 --查询列表
  showUserTractRecords (params) {
    return axios.post('/api/rendering/admin/base/user/detailinfo/queryUserTractRecords', params)
  },
  // 客户跟踪记录  --保存或修改
  saveOrUpdateUserTractRecord (params) {
    return axios.post('/api/rendering/admin/base/user/detailinfo/saveOrUpdateUserTractRecord', params)
  },
  // 客户跟踪记录  --根据id查询
  findUserTractRecord (params) {
    return axios.post('/api/rendering/admin/base/user/detailinfo/findUserTractRecord', params)
  },
  // 客户跟踪删除
  deleteUserTractRecord (params) {
    return axios.post('/api/rendering/admin/base/user/detailinfo/deleteUserTractRecords', params)
  },
  // aspera账号列表
  getAsperasList (params) {
    return axios.post('/api/rendering/admin/user/detailinfo/queryAsperas', params)
  },
  // 新增aspera账号
  addAsperas (params) {
    return axios.post('/api/rendering/admin/user/detailinfo/createAspera', params)
  },
  // 删除aspera账号
  delAsperas (params) {
    return axios.post('/api/rendering/admin/user/detailinfo/deleteAspera', params)
  },
  // 发票订单查询
  getInvoiceOrder (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryAvailableReceiptOrder', params)
  },
  // 版权云发票订单查询
  queryCopyrightAvailableReceiptOrder (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryCopyrightAvailableReceiptOrder', params)
  },
  // 发票列表查询
  getInvoiceList (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryCompletedReceipt', params)
  },
  // 发票列表查询(对接公共开票平台)
  queryCompletedReceiptV2 (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryCompletedReceiptV2', params)
  },
  // 地址列表查询
  getAddressList (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/listReceiptAddress', params)
  },
  // 发票模板查询
  getReceiptTemplate (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryReceiptTemplate', params)
  },
  // 发票最新模板查询
  queryLastReceiptTemplate (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryLastReceiptTemplate', params)
  },
  // 发票最新模板查询
  queryLastReceiptAddress (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryLastReceiptAddress', params)
  },
  // 发票列表查询（对接公共开票平台）
  queryReceiptsNew (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryReceiptsNew', params)
  },
  // 确认收款(对接公共开票平台)
  confirmReceivablesNew (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/confirmReceivablesNew', params)
  },
  // 新增发票模板
  addReceiptTemplate (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/addReceiptTemplate', params)
  },
  // 修改发票模板
  updateReceiptTemplate (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/editReceiptTemplate', params)
  },
  // 删除发票模板
  delReceiptTemplate (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/deleteReceiptTemplate', params)
  },
  // 新增发票收件地址
  addReceiptAddress (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/addReceiptAddress', params)
  },
  // 修改发票收件地址
  updateReceiptAddress (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/updateReceiptAddress', params)
  },
  // 删除发票收件地址
  delReceiptAddress (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/deleteReceiptAddress', params)
  },
  // 开具发票
  receiptInvoice (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/invoice', params)
  },
  // 上传发票附件
  uploadReceiptAnnex (params) {
    return axios.post('/api/rendering/admin/front/user/receipt/uploadReceiptAnnex', params)
  },
  //  价格更改历史
  queryPriceChangeRecord (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryPriceChangeRecord', params)
  },
  // 用户操作记录
  getUserOperations (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryUserOperations', params)
  },
  // 效果图专业版购买记录
  showPictureProByUserId (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getPictureProByUserId', params)
  },
  // 升级效果图专业版
  updatePicturePro (params) {
    return axios.post('/api/rendering/admin/base/pay/recharge/updatePicturePro', params)
  },
  // 后台人工注册
  registerUserByAdmin (params) {
    return axios.post('/api/rendering/admin/front/user/registerUserByAdmin', params)
  },
  // 验证用户名是否存在
  validateUserName (params) {
    return axios.post('/api/rendering/admin/front/user/validateUserName', params)
  },
  // 验证手机号是否存在
  validatePhone (params) {
    return axios.post('/api/rendering/admin/front/user/validatePhone', params)
  },
  // 验证邮箱是否存在
  validateEmail (params) {
    return axios.post('/api/rendering/admin/front/user/validateEmail', params)
  },
  // 某用户的退款记录
  getRefundList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getRefundListByUserId', params)
  },
  // 某用户的版权云退款记录
  getCopyrightRefundListByUserId (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getCopyrightRefundListByUserId', params)
  },
  // 客户余额统计列表
  userBalanceList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getStatisticsUserBalanceList', params)
  },
  // 平台消费明细列表
  userConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getConsumeList', params)
  },
  // 渲染券券充值明细列表
  queryUserCouponsByCondition (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/queryUserCouponRecordsByCondition', params)
  },
  // 充值记录中的渲染券券充值明细列表
  queryUserCouponsByConditionList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/queryUserCouponsByCondition', params)
  },
  // 会员充值记录列表
  queryMemberRechargesByCondition (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/queryMemberRechargesByCondition', params)
  },
  // 获取抵扣券记录列表
  queryUserVouchersByCondition (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/queryUserVouchersByCondition', params)
  },
  // 使某用户渲染券失效
  expireUserCoupons (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/expireUserCoupons', params)
  },
  // 使某用户渲染券永久有效
  updateUserCouponExpire (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/updateUserCouponExpire', params)
  },
  // 冻结用户渲染券
  freezeUserRenderingCoupon (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/freezeUserRenderingCoupon', params)
  },
  // 解冻用户渲染券
  thawUserRenderingCoupon (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/thawUserRenderingCoupon', params)
  },
  // 余额充值明细列表
  userRechargeList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getRechargeList', params)
  },
  // 退现金列表
  userRefundList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getRefundList', params)
  },
  // 版权云退款记录
  getCopyrightRefundList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getCopyrightRefundList', params)
  },
  // 会员充值记录列表
  memberRechargeList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/queryMemberRechargesByCondition', params)
  },
  // 查询版权充值明细
  copyrightRechargeList (params) {
    return axios.post('/api/rendering/admin/front/user/copyright/getCopyrightRechargeList', params)
  },
  // 查询版权充值明细
  copyrightFeeList (params) {
    return axios.post('/api/rendering/admin/front/user/copyright/getCopyrightFeeList', params)
  },
  exportCopyrightRechargeList(params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportCopyrightRecharge', params)
  },
  // 获取抵扣券记录列表
  userVoucherList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/queryUserVouchersByCondition', params)
  },
  // 导出抵扣券记录列表
  exportUserVoucherList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportUserVoucher', params)
  },
  // 导出会员充值记录列表
  exportMemberRechargeList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportMemberRecharge', params)
  },
  // 转账记录列表
  userAccountTransList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getAccountTransList', params)
  },
  // 导出客户余额统计列表
  exportUserBalanceList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportBalanceList', params)
  },
  // 导出平台消费明细列表
  exportUserConsumeList (params) {
    return exportAxios('/api/rendering/admin/statistics/pay/exportConsumeList', params)
  },
  // 导出余额充值明细列表
  exportUserRechargeList (params) {
    return axios.post('/api/rendering/admin/front/pay/export/exportRechargeList', params)
  },
  // 导出渲染券充值明细列表
  exportUserCoupons (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportUserCoupons', params)
  },
  // 导出退现金列表
  exportUserRefundList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportRefundList', params)
  },
  // 导出转账记录列表
  exportUserAccountTransList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportAccountTransList', params)
  },
  // 根据vip等级和国内外更新折扣和折扣价格
  queryPriceByVipAndZone (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryPriceByVipAndZone', params)
  },
  // 客户登录记录
  queryUserLoginInfo (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryUserLoginInfo', params)
  },
  // 解锁用户
  unlockUser (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/unLockUser', params)
  },
  // 效果图专业版升级记录
  getPictureProList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getPictureProList', params)
  },
  // 导出效果图专业版升级记录
  exportPictureProList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportPictureProList', params)
  },
  // 代理商申请
  queryAppliesByCondition (params) {
    return axios.post('/api/rendering/admin/base/user/agent/queryAppliesByCondition', params)
  },
  // 代理商申请添加备注
  insertRemark (params) {
    return axios.post('/api/rendering/admin/base/user/agent/insertRemark', params)
  },
  // 查询用户留言
  queryMessagesByPage (params) {
    return axios.post('/api/rendering/admin/front/user/messageLeave/queryMessagesByPage', params)
  },
  // 用户留言板阅读状态切换
  changeState (params) {
    return axios.post('/api/rendering/admin/front/user/messageLeave/changeState', params)
  },
  // 延长到期时间
  extendExpirationTime (params) {
    return axios.post('/api/rendering/admin/front/user/studentAuthen/extendExpirationTime', params)
  },
  // 用户留言板添加备注
  updateRemark (params) {
    return axios.post('/api/rendering/admin/front/user/messageLeave/remark', params)
  },
  // 学生认证列表查询
  queryStudentAuthens (params) {
    return axios.post('/api/rendering/admin/front/user/studentAuthen/queryStudentAuthens', params)
  },
  // 学生认证修改状态
  changeStudentAuthenStatus (params) {
    return axios.post('/api/rendering/admin/front/user/studentAuthen/changeStudentAuthenStatus', params)
  },
  // 查看学生上传图片
  queryStudentAuthenDetail (params) {
    return axios.post('/api/rendering/admin/front/user/studentAuthen/queryStudentAuthenDetail', params)
  },
  // 平台用户信息
  getOldPlatformUserInfo (params) {
    return axios.post('/api/rendering/admin/front/getOldPlatformUserInfo', params)
  },
  // 平台用户转入
  synchronizeUserById (params) {
    return axios.post('/api/rendering/admin/front/synchronizeUserById', params)
  },
  // 平台用户是否已导入
  existUser (params) {
    return axios.post('/api/rendering/admin/front/user/existUser', params)
  },
  // 根据任务号获取最大返还金额
  getReturnAmountByTaskId (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/getReturnAmountByTaskId', params)
  },
  // 修改用户详情-基本信息
  updateUserBaseInfo (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateUserBaseInfo', params)
  },
  // 修改用户详情-价格设置-动画价格
  updateUserAccount (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateUserAccount', params)
  },
  // 修改用户详情-价格设置-可用金额预警
  updateUserAccountBalancePrompt (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateUserAccountBalancePrompt', params)
  },
  // 查询用户详情-价格设置-云制作用户单价
  getCloudProductionUserPrice (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/getCloudProductionUserPrice', params)
  },
  // 修改用户详情-价格设置-云制作用户单价
  updateCloudProductionUserPrice (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateCloudProductionUserPrice', params)
  },
  // 修改用户详情-渲染设置
  updateRenderSetting (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateRenderSetting', params)
  },
  // 修改用户详情-风险服务
  updateRenderService (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateRenderService', params)
  },
  enabledUser (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/enabledUser', params)
  },
  enabledUserBatch (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/batchEnabledUsers', params)
  },
  // 用户列表-激活
  /**
   * @param {number} userId
   * @returns {axios.post}
   */
  activeUser ({userId}) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/activeUser', {userId})
  },
  // 根据部门id查询管理员列表
  /**
   * @param {array} organizationIds
   * @returns {axios.post}
   */
  queryAdminsByOrganizationIds ({organizationIds}) {
    return axios.post('/api/rendering/admin/base/user/queryAdminsByOrganizationIds', {organizationIds})
  },
  // 更新用户存储分配
  /**
   * @param {object} {"userId":100001,"platform":2,"mountId":1}
   * @returns {axios.post}
   */
  updateMountPath (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/addUserPath', params)
  },
  // 修改用户详情-平台渲染设置
  updateLocalRenderSet (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateLocalRenderSet', params)
  },
  // 修改用户详情-平台渲染设置-硬件型号
  updateDefaultHardwareConfig (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateDefaultHardwareConfig', params)
  },
  // 新增用户详情-平台渲染设置
  addLocalRenderSet (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/addLocalRenderSet', params)
  },
  // 删除用户
  deleteUser (params) {
    return axios.post('/api/rendering/admin/front/user/deleteUser', params)
  },

  // 包机信息列表 查询列表
  queryUserPackNode (params) {
    return axios.post('/api/rendering/admin/task/pack/queryPackNode', params)
  },
  // 包机信息保存或修改
  saveOrUpdateUserPackNode (params) {
    return axios.post('/api/rendering/admin/task/pack/saveOrUpdatePackNode', params)
  },
  // 根据ID查询包机信息
  findUserPackNode (params) {
    return axios.post('/api/rendering/admin/task/pack/findPackNode', params)
  },
  // 删除包机信息
  deleteUserPackNode (params) {
    return axios.post('/api/rendering/admin/task/pack/deletePackNode', params)
  },

  // 包项目信息列表 查询列表
  queryUserPackProject (params) {
    return axios.post('/api/rendering/admin/task/pack/queryPackProject', params)
  },
  // 包项目信息保存或修改
  saveOrUpdateUserPackProject (params) {
    return axios.post('/api/rendering/admin/task/pack/saveOrUpdatePackProject', params)
  },
  // 根据ID查询包项目信息
  findUserPackProject (params) {
    return axios.post('/api/rendering/admin/task/pack/findPackProject', params)
  },
  // 删除包项目信息
  deleteUserPackProject (params) {
    return axios.post('/api/rendering/admin/task/pack/deletePackProject', params)
  },
  // 获取用户项目列表
  getUserProjectList (params) {
    return axios.post('/api/rendering/admin/task/pack/getUserProjectList', params)
  },
  /**
   * 获取用户租赁列表
   * @param {int} pageSize
   * @param {int} pageNum
   * @param {string} [userName] 用户名
   * @param {int} [userId] 用户Id
   */
  queryNodeRentals (params) {
    return axios.post('/api/rendering/admin/task/node/rent/queryNodeRentals', params)
  },
  /**
   * 查询租赁
   * @param {int} pageSize
   * @param {int} pageNum
   * @param {string} [userName] 用户名
   * @param {int} [userId] 用户Id
   */
  exportNodeRentals (params) {
    return exportAxios('/api/rendering/admin/task/node/rent/exportNodeRentals', params)
  },
  /**
   * 添加租赁
   * @param {int} [id] 当id不为空为新增，否则为修改
   * @param {string} userName 用户名
   * @param {int} userId 用户Id
   * @param {string} totalCost 租期内总费用
   * @param {string} overdueUnitPrice 超期单价
   * @param {string} [remark] 备注
   * @param {int} currency 币种（1；RMB 2:USD）
   * @param {string} startTime 开始时间
   * @param {string} endTime 结束时间
   */
  addOrUpdateNodeRental (params) {
    return axios.post('/api/rendering/admin/task/node/rent/addOrUpdateNodeRental', params)
  },
  /**
   * 删除租赁
   * @param {int} id 编号
   */
  deleteNodeRental (params) {
    return axios.post('/api/rendering/admin/task/node/rent/deleteNodeRental', params)
  },

  /**
   * 包机消费记录列表
   * @param {Int} pageNum 每页条数
   * @param {Int} pageSize 当前页
   * @param {Int} [userId] 用户id
   * @param {String} [userName] 用户名
   * @param {String} [startDate] 开始日期
   * @param {String} [endTime] 结束日期
   * @param {String} [mainUsername] 主账号名称
   * @param {Int} [isDomestic] 1:国内 2:国外
   * @param {String} [remark] 用户备注
   * @param {Int} [agentId] 代理ID
   * @param {Int} [consumeAmount] 消费额度筛选条件
                                * 1:消费金额<500
                                * 2:500<消费金额<2000
                                * 3:2000<消费金额<10000
                                * 4:10000<消费金额<50000
                                * 5:50000<消费金额<100000
                                * 6:>100000
   * @param {Int} [timeStatus] 时间区间
                                * 0:按开始时间
                                * 1:按结束时间
                                * 2:按时间区间
   */
  getPackNodeConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getPackNodeConsumeList', params)
  },
  /**
   * 导出包机消费记录列表
   * @param {*} 同上
   */
  exportPackNodeConsumeList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportPackNodeConsumeList', params)
  },
  /**
   * 获取包项目消费记录列表
   * @param {*} 同上
   */
  getPackProjectConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getPackProjectConsumeList', params)
  },
  /**
   * 导出包项目消费记录列表
   * @param {*} 同上
   */
  exportPackProjectConsumeList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportPackProjectConsumeList', params)
  },
  /**
   * 获取租赁消费记录列表
   * @param {*} 同上
   */
  getRentNodeConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getRentNodeConsumeList', params)
  },
  /**
   * 导出租赁消费记录列表
   * @param {*} 同上
   */
  exportRentNodeConsumeList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportRentNodeConsumeList', params)
  },
  /**
   * 获取租赁过期消费记录列表
   * @param {*} 同上
   */
  getRentNodeOverdueConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getRentNodeOverdueConsumeList', params)
  },
  /**
   * 导出租赁过期消费记录列表
   * @param {*} 同上
   */
  exportRentNodeOverdueConsumeList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportRentNodeOverdueConsumeList', params)
  },
  // 客户端意见反馈
  getClientFeedback (params) {
    return axios.post('/api/rendering/admin/front/user/feedback/queryUserFeedback', params)
  },
  // 客户端意见反馈修改备注
  updateFeedbackRemark (params) {
    return axios.post('/api/rendering/admin/front/user/feedback/updateUserFeedback', params)
  },
  // 导出用户月消费清单
  exportUserMonthConsumeList (params) {
    return exportAxios('/api/rendering/admin/front/pay/export/exportConsumeStatistics', params)
  },
  // 查询用户详情-本地渲染设置
  queryLocalRenderSets (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryLocalRenderSets', params)
  },
  //  主子账号：更新主账号总额度
  updateTotalCredit (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateTotalCredit', params)
  },
  // 主子账号：更新子账号额度
  updateCredit (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/updateCredit', params)
  },
  // 查询子账号
  querySubsByUserId (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/querySubsByUserId', params)
  },
  // 获取微信自动回复列表
  getWechatMsgList (params) {
    return axios.post('/api/rendering/admin/front/user/wechatmsg/msgList', params)
  },
  // 增加微信自动回复
  addWechatMsg (params) {
    return axios.post('/api/rendering/admin/front/user/wechatmsg/addMsgs', params)
  },
  // 更新微信自动回复
  updateWechatMsg (params) {
    return axios.post('/api/rendering/admin/front/user/wechatmsg/updateMsgs', params)
  },
  // 删除微信自动回复
  deleteWechatMsg (params) {
    return axios.post('/api/rendering/admin/front/user/wechatmsg/deleteMsgs', params)
  },
  // 强制用户退出
  forceLogout (params) {
    return axios.post('/api/rendering/admin/front/user/forceLogout', params)
  },
  // 解除IP登录限制
  releaseUserIpLimit (params) {
    return axios.post('/api/rendering/admin/front/user/releaseUserIpLimit', params)
  },
  // 清除用户登录限制
  cleanLoginLimit (params) {
    return axios.post('/api/rendering/admin/front/user/releaseUserLoginFail', params)
  },
  // 企业认证列表查询
  queryCertificationList (params) {
    return axios.post('/api/rendering/admin/front/user/enterprise/queryCertificationList', params)
  },
  // 同意/驳回申请企业认证
  updateCertification (params) {
    return axios.post('/api/rendering/admin/front/user/enterprise/updateCertification', params)
  },
  // 查询企业认证详细信息
  queryCertification (params) {
    return axios.post('/api/rendering/admin/front/user/enterprise/queryCertification', params)
  },
  // 查询联系方式黑名单
  getContactBlacklist (params) {
    return axios.post('/api/rendering/admin/front/user/contact/getContactBlacklist', params)
  },
  // 删除联系方式黑名单
  deleteContactBlacklist (params) {
    return axios.post('/api/rendering/admin/front/user/contact/deleteContactBlacklist', params)
  },
  // 新增联系方式黑名单
  addContactBlacklist (params) {
    return axios.post('/api/rendering/admin/front/user/contact/addContactBlacklist', params)
  },
  // 查询版权登记记录
  getCopyRightRegistrationList(params) {
    return axios.post('/api/rendering/admin/front/user/copyright/getCopyrightRegisterList', params)
  },
  // 设置额度回调
  setQuotaControl (params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/setQuotaControl', params)
  },
  // 获取可赠送的订单列表
  getRecordListToPresent (params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/getRecordListToPresent', params)
  },
  // 查询对账单
  queryFinanceBills (params) {
    return axios.post('/api/rendering/admin/front/finance/financeVerifyBills/queryFinanceBills', params)
  },
  // 上传对账单
  uploadFinanceBills (params) {
    return axios.post('/api/rendering/admin/front/finance/financeVerifyBills/uploadFinanceBill', params, {
      headers: {
        'content-type': 'multipart/form-data;',
      },
    })
  },
  // 校对对账单
  startVerifyBill (params) {
    return axios.post('/api/rendering/admin/front/finance/financeVerifyBills/startVerifyBill', params)
  },
  // 下载对账单
  downloadFinanceBills (params) {
    return exportAxios('/api/rendering/admin/front/finance/financeVerifyBills/downloadFinanceBills', params)
  },
  // 删除对账单
  deleteVerifyBill (params) {
    return axios.post('/api/rendering/admin/front/finance/financeVerifyBills/deleteVerifyBill', params)
  },
  // 获取用户消费月账单总览
  getUserMonthBillBriefs (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getUserMonthBillBriefs', params)
  },
  // 获取用户云制作账单总览
  getUserCloudProductionMonthBillBriefs (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getUserCloudProductionMonthBillBriefs', params)
  },
  // 导出云制作消费总览
  exportCloudProductionBrief (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/exportCloudProductionBrief', params)
  },
  // 导出用户云制作账单明细
  exportUserCloudProductionBillDetails (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/exportUserCloudProductionBillDetails', params)
  },
  // 获取用户云制作账单明细
  getUserCloudProductionBillDetails (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getUserCloudProductionBillDetails', params)
  },
  // 获取用户云制作月账单
  getUserCloudProductionMonthBills (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getUserCloudProductionMonthBills', params)
  },
  // 下载用户云制作月账单
  downloadCloudProductionBills (params) {
    return exportAxios('/api/rendering/admin/front/pay/consume/bill/downloadCloudProductionBills', params)
  },
  // 导出月账单
  exportUserMonthBillBriefList (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/exportUserMonthBillBriefList', params)
  },
  // 获取用户月账单
  getUserMonthBills (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getUserMonthBills', params)
  },
  // 账单申诉详情
  billAppealDetails (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/billAppealDetails', params)
  },
  // 提交账单申诉结果
  submitBillAppealResults (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/submitBillAppealResults', params)
  },
  // 下载用户月账单
  downloadUserMonthBill (params) {
    return exportAxios('/api/rendering/admin/front/pay/consume/bill/downloadUserMonthBill', params)
  },
  // 获取用户消费账单明细
  getUserBillDetails (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getUserBillDetails', params)
  },
  getExportFrameConsumeListCount(params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getExportFrameConsumeListCount', params)
  },
  // 导出用户账单
  exportUserBillDetails (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/exportUserBillDetails', params)
  },
  // 导出作业帧详情消费账单
  exportFrameConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/exportFrameConsumeList', params)
  },
  // 导出用户硬件型号消费账单.
  exportUserBillByHardware (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/exportUserBillByHardware', params)
  },
  // 获取用户效果图会员购买明细
  getPictureMemberConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getPictureMemberConsumeList', params)
  },
  // 导出用户效果图会员购买明细
  exportPictureMemberConsumeList (params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/exportPictureMemberConsumeList', params)
  },
  // 查询企业税号
  queryEnterpriseTicketUncID(params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryEnterpriseTicketUncID', params)
  },
  // 模糊查询企业纳税相关信息
  queryEnterpriseTicket(params) {
    return axios.post('/api/rendering/admin/front/user/receipt/queryEnterpriseTicket', params)
  },
  getUserBillTotalConsume(params) {
    return axios.post('/api/rendering/admin/front/pay/consume/bill/getUserBillTotalConsume', params)
  },
  // 余额充值与调整（银行流水号/银行流水金额/对账备注修改）
  updatePayRecord(params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/updatePayRecord', params)
  },
  // 会员购买明细（银行流水金额/对账备注修改）
  updateMemberRechargeRecord(params) {
    return axios.post('/api/rendering/admin/front/pay/recharge/list/updateMemberRechargeRecord', params)
  },
  // 版权消费明细（银行流水金额/对账备注修改）
  updateCopyrightRechargeRecord(params) {
    return axios.post('/api/rendering/admin/front/user/copyright/updateCopyrightRechargeRecord', params)
  },
  // 查询代理商申请列表
  selectAgentApplyList(params) {
    return axios.post('/api/rendering/admin/base/user/agent/selectAgentApplyList', params)
  },
  // 代理审核
  verifyAgent(params) {
    return axios.post('/api/rendering/admin/base/user/agent/verifyAgent', params)
  },
  // 上传文件
  uploadFile(params) {
    return axios.post('/api/rendering/admin/base/user/agent/uploadProtocolFile', params)
  },
  // 查询所有用户授权
  queryAllUserPermission(params) {
    return axios.post('/api/rendering/admin/front/user/queryAllUserPermission', params)
  },
  // 获得所有子用户
  querySubUserByMainUserId(params) {
    return axios.post('/api/rendering/admin/front/user/querySubUserByMainUserId', params)
  },
  // 导出版权登记列表
  exportList(params) {
    return axios.post('/api/rendering/admin/front/user/copyright/exportCopyrightRegisterList', params)
  },
  getViewUserInfo(params) {
    return axios.post('/api/rendering/admin/front/viewUserInfo', params)
  },
  queryDingTalkDeptById(params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryDingTalkDeptById', params)
  },
  queryUserAndDingTalkSubUsersById(param) {
    return axios.post(
      '/api/rendering/admin/front/user/detailinfo/queryUserAndDingTalkSubUsersById',
      param,
    )
  },
  // 查询用户反馈(FOX和效果图客户端)
  queryUserFeedbackNew(param) {
    return axios.post(
      '/api/rendering/admin/front/user/feedback/queryUserFeedbackNew',
      param,
    )
  },
  // 查询用户反馈(动画客户端)
  queryClientFeedback(param) {
    return axios.post(
      '/api/rendering/admin/front/user/feedback/queryClientFeedback',
      param,
    )
  },
  // 修改备注或状态(FOX和效果图客户端)
  updateUserFeedbackNew(param) {
    return axios.post(
      '/api/rendering/admin/front/user/feedback/updateUserFeedbackNew',
      param,
    )
  },
  // 查询反馈客户端版本列表
  queryFeedbackVersions(param) {
    return axios.post(
      '/api/rendering/admin/front/user/feedback/queryFeedbackVersions',
      param,
    )
  },
  // 下载图片
  downloadImages(param) {
    return exportAxios(
      '/api/rendering/admin/front/user/feedback/downloadImages',
      param,
    )
  },
  adminRechargeMember(param) {
    return axios.post(
      '/api/rendering/admin/front/pay/recharge/adminRechargeMember',
      param,
    )
  },
  // 查询用户查重列表
  getPlagiarismCheck(param) {
    return axios.post(
      '/api/rendering/admin/front/plagiarismCheck',
      param,
    )
  },
  // 用户查重领取
  receiveUser(params) {
    return axios.post(
      '/api/rendering/admin/front/receiveUser',
      params,
    )
  },
  // 上传-批量分配业务员
  uploadBatchAssignSalesperson(params) {
    return axios.post('/api/rendering/admin/base/user/uploadBatchAssignSalesperson', params)
  },
  // 查询批量分配业务员列表接口
  getBatchAssignSalespersonList(params) {
    return axios.post('/api/rendering/admin/base/user/getBatchAssignSalespersonList', params)
  },
  // 下载批量分配业务员失败接口
  downloadBatchAssignSalespersonFailedData(params) {
    return exportAxios('/api/rendering/admin/base/user/downloadBatchAssignSalespersonFailedData', params)
  },
  // 生成支付二维码
  generateQrCodePaymentOrder(param) {
    return axios.post(
      '/api/rendering/admin/front/pay/recharge/generateQrCodePaymentOrder',
      param,
    )
  },
  transferAccount(param) {
    return axios.post(
      '/api/rendering/admin/front/user/transferAccount',
      param,
    )
  },
  /**
   * 生成青云券支付二维码
   * @param {Object} param - 参数
   * @param {number} param.userId - 用户Id
   * @param {number} param.amount - 设置金额（范围：0-30000）
   * @param {number} param.payMethod - 支付方式（1：支付宝支付 2：微信支付）
   * @param {number} param.couponType - 青云券类型（4：CPU青云券，6：GPU青云券）
   * @param {number} param.couponAmount - 到账青云券金额（范围：仅支持输入≦7倍充值金额的正整数）
   * @returns {Promise} - 返回Promise
  */
  generateQrCodePaymentQYOrder(param) {
    return axios.post(
      '/api/rendering/admin/front/pay/recharge/generateQrCodePaymentQYOrder',
      param,
    )
  },
  // 下载匹配邮箱模板
  getMatchEmailTemplate() {
    return exportAxios('/api/rendering/admin/front/user/getMatchEmailTemplate')
  },
  // 上传匹配邮箱
  uploadMatchEmailInfo(params) {
    return axios.post('/api/rendering/admin/front/user/uploadMatchEmailInfo', params)
  },
  // 查询用户json文件定制列表
  queryUserJsonFileCustomizationList(params) {
    return axios.post('/api/rendering/admin/task/config/user/queryUserJsonFileCustomizationList', params)
  },
  // 新增Json定制文件-校验用户json文件定制是否存在
  checkUserJsonFileCustomization(params) {
    return axios.post('/api/rendering/admin/task/config/user/checkUserJsonFileCustomization', params)
  },
  // 新增用户json文件定制
  addUserJsonFileCustomization(params) {
    return axios.post('/api/rendering/admin/task/config/user/addUserJsonFileCustomization', params)
  },
  // 根据id查询用户json文件定制
  queryUserJsonFileCustomizationById(params) {
    return axios.post('/api/rendering/admin/task/config/user/queryUserJsonFileCustomizationById', params)
  },
  // 根据id修改用户json文件定制
  editUserJsonFileCustomizationById(params) {
    return axios.post('/api/rendering/admin/task/config/user/editUserJsonFileCustomizationById', params)
  },
  // 根据id删除用户json文件定制
  deleteUserJsonFileCustomizationById(params) {
    return axios.post('/api/rendering/admin/task/config/user/deleteUserJsonFileCustomizationById', params)
  },
  // 根据id同步至其他平台
  syncCurrentUserOtherPlatformById(params) {
    return axios.post('/api/rendering/admin/task/config/user/syncCurrentUserOtherPlatformById', params)
  },
  // 根据id同步至其他账号
  syncOtherUserPlatformById(params) {
    return axios.post('/api/rendering/admin/task/config/user/syncOtherUserPlatformById', params)
  },
  // 根据id同步至其他账号
  customUserCleanFile(params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/customUserCleanFile', params)
  },
  // 查询用户详情-平台显示
  queryPlatformUserLimit (params) {
    return axios.post('/api/rendering/admin/task/platform/queryPlatformUserLimit', params)
  },
  // 社媒记录
  getSocialMediaRecord(params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryThirdAccountBindList', params)
  },
  // 解绑社媒
  unbindSocialMedia(params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/unBindThirdAccount', params)
  },
  // 查看邮箱拦截情况
  queryBlacklistInterceptRecord (params) {
    return axios.post('/api/rendering/admin/front/user/contact/queryBlacklistInterceptRecord', params)
  },
}
